import React, { useEffect, useState } from "react";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";

import { getLoggedProfile, logout } from "../../actions/sessionAct";

import Header from "../components/header";
import Footer from "../components/footer";
import Session from "../common/session";
import Login from "../login/login";
import SignUp from "../login/signup";

import img from "../../static/images/empty/empty-del-account.svg";

import { HOME } from "../../constant/routes";

const SuccessBox = ({ show, onHide, dispatch, history }) => {
	const deleteAccount = () => {
		onHide();
		dispatch(logout());
		history.push(HOME);
	};

	return (
		<Modal show={show} onHide={deleteAccount} dialogClassName="modal-s modal-dialog modal-text">
			<Modal.Header closeButton={true} closeLabel={""}>
				<h5>Thông báo</h5>
			</Modal.Header>
			<Modal.Body>
				<div className="modal-text-body">
					<p className="textAlign-center">Yêu cầu xóa tài khoản thành công.</p>
					<div className="wrap-btn">
						<a className="btn btn-primary btn--m" onClick={deleteAccount}>
							Đóng
						</a>
					</div>
				</div>
			</Modal.Body>
		</Modal>
	);
};

function mapState(state) {
	return {
		session: state.session,
	};
}

const ConnectedSuccessBox = withRouter(connect(mapState)(SuccessBox));

const ConfirmBox = ({ show, onHide }) => {
	const [success, setSuccess] = useState(false);

	const showSuccessBox = () => {
		onHide();
		setSuccess(true);
	};
	return (
		<>
			<Modal show={show} onHide={onHide} dialogClassName="modal-s modal-dialog modal-text">
				<Modal.Header closeButton={true} closeLabel={""}>
					<h5>Xác nhận</h5>
				</Modal.Header>
				<Modal.Body>
					<div className="modal-text-body">
						<p className="textAlign-center">Bạn có chắc chắn muốn xoá tài khoản?</p>
						<div className="wrap-btn">
							<a className="btn btn-primary btn--m" onClick={showSuccessBox}>
								Tiếp tục
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			<ConnectedSuccessBox show={success} onHide={() => setSuccess(false)} />
		</>
	);
};

const DeleteAccount = ({ session, dispatch }) => {
	const [confirm, setConfirm] = useState(false);
	const [login, setLogin] = useState(false);
	const [showSignup, setSignup] = useState(false);
	const { profile } = session;

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const getLogged = () => {
		dispatch(getLoggedProfile());
	};

	const deleteHandle = () => {
		const logged = profile?.info?.uid;
		if (logged) {
			setConfirm(true);
		} else {
			setLogin(true);
		}
	};

	const openSignupForm = () => {
		setSignup(true)
	}

	const closeSignupForm = () => {
		setSignup(false)
	}
	

	return (
		<div className="mioto-layout">
			{/* <Session notAutoLogin={true} /> */}
			<Header />
			<section className="body">
				<div className="del-account-section space sec">
					<div className="m-container">
						<h4>Yêu cầu xóa tài khoản</h4>
						<div className="del-account-content">
							<img loading="lazy" src={img} />
							<div className="content-inner">
								<p>Khi xóa tài khoản, các thông tin sau (nếu có) sẽ bị xóa trên hệ thống:</p>
								<ul>
									<li>Thông tin cá nhân</li>
									<li>Thông tin lịch sử chuyến và danh sách xe</li>
								</ul>
								<p>Tiền ví và điểm thưởng sẽ được thanh toán theo quy định và chính sách hiện hành của Mioto.</p>
								<p>Việc đồng ý xóa tài khoản là bạn đã chấp nhận điều khoản chính sách xóa tài khoản của Mioto.</p>
								<p>
									Yêu cầu xóa tài khoản sẽ được xử lý trong vòng 15 ngày làm việc. Mioto sẽ liên hệ trực tiếp với bạn
									thông qua Email hoặc Số điện thoại đã cung cấp.
								</p>
								<p>Mọi thắc mắc xin liên hệ Fanpage của Mioto hoặc Hotline 1900 9217 (7AM - 10PM) để được hỗ trợ.</p>
							</div>
							<div className="wrap-btn has-2-btn">
								<a className="btn btn--m btn-red" onClick={deleteHandle}>
									Xóa tài khoản
								</a>
								<Link to={HOME} className="btn btn-link">
									Hủy
								</Link>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
			<ConfirmBox show={confirm} onHide={() => setConfirm(false)} />
			<Login
				show={login}
				showModal={() => setLogin(true)}
				getLoggedProfile={getLogged}
				hideModal={() => setLogin(false)}
				openSignupForm={openSignupForm}
			/>
			<SignUp
				show={showSignup}
				showModal={openSignupForm}
				hideModal={closeSignupForm}
				openLoginForm={() => setLogin(true)}
				getLoggedProfile={getLogged}
			/>
		</div>
	);
};

export default connect(mapState)(DeleteAccount);
